import React, {useState} from 'react'
import {DeviceModel, OwnershipType} from '../../../../entities/device.entity'
import PrimaryButton from '../common/buttons/PrimaryButton'

interface AssignBulkDevicesDoctorModalProps {
  isOpen: boolean
  onClose: () => void
  availableDevices: DeviceModel[]
  handleAssign: (devices: DeviceModel[], ownershipType: OwnershipType, resetForm: () => void) => void
  isAssigning?: boolean
}

const AssignBulkDevicesDoctorModal = ({
  isOpen,
  onClose,
  availableDevices,
  handleAssign,
  isAssigning = false,
}: AssignBulkDevicesDoctorModalProps) => {
  const [selectedDevices, setSelectedDevices] = useState<DeviceModel[]>([])
  const [ownershipType, setOwnershipType] = useState<OwnershipType>('rental')

  const handleClose = () => {
    setSelectedDevices([])
    setOwnershipType('rental')
    onClose()
  }

  const toggleDeviceSelection = (device: DeviceModel) => {
    setSelectedDevices((prevSelected) =>
      prevSelected.some((d) => d.id === device.id)
        ? prevSelected.filter((d) => d.id !== device.id)
        : [...prevSelected, device]
    )
  }

  const handleAssignClick = () => {
    handleAssign(selectedDevices, ownershipType, () => {
      setSelectedDevices([])
      setOwnershipType('rental')
    })
  }

  return (
    <>
      {isOpen && (
        <div
          onClick={handleClose}
          className='modal-backdrop show'
          style={{backgroundColor: 'rgba(0, 0, 0, 0.5)'}}
        />
      )}
      <div className={`modal fade ${isOpen ? 'show d-block' : ''}`} tabIndex={-1}>
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>Assign Devices</h5>
              <button type='button' className='btn-close' onClick={handleClose}></button>
            </div>
            <div className='modal-body'>
              <div className='d-flex justify-content-between align-items-center'>
                <h5 className='mb-0'>Available Devices</h5>

                <div className='d-flex gap-3'>
                  {(['rental', 'purchased', 'loaned'] as OwnershipType[]).map((type) => (
                    <div className='form-check' key={type}>
                      <input
                        className='form-check-input'
                        type='radio'
                        name='bulkOwnershipType'
                        id={`bulk-${type}`}
                        checked={ownershipType === type}
                        onChange={() => setOwnershipType(type)}
                        disabled={isAssigning}
                      />
                      <label className='form-check-label' htmlFor={`bulk-${type}`}>
                        {type.charAt(0).toUpperCase() + type.slice(1)}
                      </label>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{maxHeight: '300px', overflowY: 'auto'}}>
                {availableDevices.length > 0 ? (
                  availableDevices.map((device) => {
                    const isSelected = selectedDevices.some((d) => d.id === device.id)
                    return (
                      <div
                        key={device.id}
                        className={`d-flex justify-content-between align-items-center p-2 border rounded mb-2 ${
                          isSelected ? 'bg-primary text-white' : ''
                        }`}
                        onClick={() => !isAssigning && toggleDeviceSelection(device)}
                        style={{cursor: isAssigning ? 'not-allowed' : 'pointer'}}
                      >
                        <div>
                          <strong>{device.name}</strong> <br />
                          <small>IMEI: {device.imei}</small> <br />
                          <small>Model No: {device.model_no}</small> <br />
                          <small>Type: {device.DeviceType?.name}</small>
                        </div>
                        <button
                          className={`btn btn-sm ${isSelected ? 'btn-secondary' : 'btn-primary'}`}
                          onClick={(e) => {
                            e.stopPropagation()
                            if (!isAssigning) {
                              toggleDeviceSelection(device)
                            }
                          }}
                          disabled={isAssigning}
                        >
                          {isSelected ? 'Deselect' : 'Select'}
                        </button>
                      </div>
                    )
                  })
                ) : (
                  <p className='text-muted'>No available devices</p>
                )}
              </div>
            </div>

            <div className='modal-footer'>
              <PrimaryButton
                className=''
                onClick={handleAssignClick}
                disabled={selectedDevices.length === 0 || isAssigning}
              >
                {isAssigning ? 'Assigning...' : `Assign Devices (${selectedDevices.length})`}
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AssignBulkDevicesDoctorModal
